import React from 'react';

export const Tables = props => <div>Style Guide Tables</div>;



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/Tables.js